import { entries } from "./entries";
import { leagues as leagueActions } from "./leagues";
import { matches } from "./matches";
import { seasons } from "./seasons";

export const leagues = { ...leagueActions, entries, matches, seasons };
